import React, { Component } from 'react'
import './BlockUserListDialog.scss'

import axios from 'axios';
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { Dialog } from "@material-ui/core";
import { connect } from 'react-redux'
import i18n from '../../i18n';
import { FetchBlockUserList } from '../../Interface'

const closeStyle = {
    right: "10px",
    background: "#fff",
    top: "10px",
    width: "40px",
    height: "40px"
}

class BlockUserDialog extends Component {
    state = {}

    blockedListArr = []

    componentDidMount() {
        this.setBlockedList()
    }

    // componentDidUpdate() {
    //     this.setBlockedList()
    // }

    componentWillUnmount() {
        FetchBlockUserList()
        this.blockedListArr = []
    }

    dialogOnClose = () => {
        const { onClose } = this.props
        FetchBlockUserList()
        this.updateBlockList()
        onClose()
    }

    setBlockedList = () => {
        const { blockUsers } = this.props
        
        if (Array.isArray(this.blockedListArr) && this.blockedListArr.length > 0) return

        if (Object.keys(blockUsers).length > 0) {
            this.blockedListArr = Object.keys(blockUsers).map(item => {
                const { userShareId, userid, username, date, profileURL } = blockUsers[item]

                return {
                    userShareId,
                    userid,
                    username,
                    date,
                    profileURL,
                    isBlocked: true
                }
            })
        }
        else {
            this.blockedListArr = []
        }
    }

    updateBlockList = () => {
        this.blockedListArr = this.blockedListArr.filter(item => item.isBlocked)
    }

    // isBlocked === false => 차단X -> 차단 / isBlocked === true => 차단 -> 차단해제
    handleClickBlockBtn = async userInfo => {
        const { isBlocked, userid } = userInfo
        const token = localStorage.getItem("token")
        const config = { headers: { Authorization: `Bearer ${token}` } }
        try {
            if (isBlocked) {
                await axios.delete(`${GetBaseUrl()}/apis/users/block-user/${userid}`, config)
            }
            else {
                await axios.post(`${GetBaseUrl()}/apis/users/block-user`,{ id: userid }, config)
            }

            this.blockedListArr.forEach(item => {
                if (item.userid === userid) {
                    item.isBlocked = !isBlocked
                }
            })

            this.setState({})
        } catch (e) {
            if (e.response && e.response.data) {
                const { error_code } = e.response.data

                if (error_code === 'ERR_ALREADY_EXIST') {
                    alert(i18n.t('user.block.error.already.block'))
                }
            }
        }
    }

    render() {
        const { open } = this.props

        return (
            <Dialog fullWidth={this.props.fullWidth} maxWidth={"lg"} open={open} onClose={this.dialogOnClose}>
                <div className='block-user-list-main-container'>
                    <div className="closeBtn" style={closeStyle} onClick={this.dialogOnClose}>
                        <div style={{ top: "18px" }} className="closeBar1" />
                        <div style={{ top: "18px" }} className="closeBar2" />
                    </div>
                    <div className='block-user-list-title-container'>
                        {i18n.t("block.user.dialog.title")}
                    </div>
                    <div className='block-user-list-data-container'>
                        {
                            Array.isArray(this.blockedListArr) &&
                            this.blockedListArr.map(item => (
                                <div className='block-user-list-item'>
                                    <div className='block-user-list-item-left'>
                                        <div className='list-item-profile-area'>
                                            <img src={`${item.profileURL ? item.profileURL : 'https://front.videomonster.com/images-7cuytg20/common/v2-profile.svg'}`} />
                                        </div>
                                        <div className='list-item-nickname-area'>
                                            {item.username}
                                        </div>
                                    </div>
                                    <div className='block-user-list-item-right'>
                                        <div className={`block-user-item-btn ${!item.isBlocked ? 'blocked' : ''}`} onClick={() => this.handleClickBlockBtn(item)}>
                                            {i18n.t(`block.user.dialog.${!item.isBlocked ? 'block' : 'unblock'}.btn`)}
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </Dialog>
        )
    }
}

const mapStateToProps = state => ({
    blockUsers: state.blockUserStore.blockUsers
  })

export default connect(mapStateToProps, null)(BlockUserDialog)